import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, Container } from "@mui/material";
import Wave from "../../components/wave";
import theme from "../../styles/theme";
import Hero from "../../components/home/hero";
import FeatureSection from "../../components/home/feature";
import ProductsSection from "../../components/home/products";
import GallerySection from "../../components/home/gallery";
import AboutSection from "../../components/home/about";
import ContactSection from "../../components/home/contact";
import { MarketingBody, MarketingIntro } from "../../components/search/PublicContent";
import { getSearchPage } from "../../utils/searchMetadata";

function Home() {
  const location = useLocation();

  useEffect(() => {
    const hashValue = (location.hash || "").replace("#", "");
    if (!hashValue) return;

    let frame;
    let cancelled = false;
    // Font loading can change line wrapping and move a section during a smooth scroll.
    document.fonts.ready.then(() => {
      if (cancelled) return;
      frame = requestAnimationFrame(() => {
        const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth";
        if (hashValue === "hero") {
          window.scrollTo({ top: 0, behavior });
          return;
        }

        const targetElement = document.getElementById(hashValue);
        if (!targetElement) return;

        targetElement.scrollIntoView({ behavior, block: "start" });
      });
    });
    return () => {
      cancelled = true;
      cancelAnimationFrame(frame);
    };
  }, [location.hash, location.key]);

  return (
    <Container
      component="div"
      maxWidth="xxl"
      sx={{
        "& #products, & #about, & #contact": {
          scrollMarginTop: { xs: "72px", sm: "80px" },
        },
      }}
      style={{ paddingLeft: "0px", paddingRight: "0px", textAlign: "center" }}
    >
      <Hero />
      <Wave
        amplitude={60}
        duration={5}
        fillStyle={theme.palette.background.default2}
        frequency={3.0}
        waveHeightRatio={0.3}
      />
      <Box sx={{ backgroundColor: "background.default2" }}>
        <MarketingIntro page={getSearchPage("/")} />
      </Box>
      <ProductsSection />
      <GallerySection />
      <FeatureSection />
      <AboutSection />
      <MarketingBody page={getSearchPage("/")} />
      <ContactSection />
    </Container>
  );
}

export default Home;
